

































import Vue from 'vue'
import Component from 'vue-class-component'
import { VPopover } from 'v-tooltip'

@Component({
  components: { VPopover },
  props: {
    optionsList: {
      default: () => []
    }
  }
})
export default class FilterOptions extends Vue {
  showOptions: boolean = false

  selectOption (value: string) {
    this.$emit('selectOption', value)
    this.setShowOptions(false)
  }

  setShowOptions (value: boolean) {
    this.showOptions = value
  }
}
